import { createContext, useContext } from 'react';

import { CURRENCY_SYMBOLS } from './currencyConstants';
import type { CurrencyCode } from './currencyConstants';

export type { CurrencyCode } from './currencyConstants';

type CurrencyContextType = {
  currency: CurrencyCode;
  currencySymbol: string;
  setCurrency: (currency: CurrencyCode) => void;
};

const defaultCurrency: CurrencyCode = 'USD';

export const CurrencyContext = createContext<CurrencyContextType>({
  currency: defaultCurrency,
  currencySymbol: CURRENCY_SYMBOLS.USD,
  setCurrency: () => {},
});

export default function useCurrency() {
  return useContext(CurrencyContext);
}
